import { combineReducers } from 'redux';

import cancelSiteArticleError from './cancelSiteArticleError';


export default combineReducers({
  cancelSiteArticleError,
});
